import { IPayload } from 'models/Global'
import { IGetShiftsParams, IShift } from 'models/Shift'
import {
  IActivityLog,
  IGetActivityLogsParams,
  IGetShiftNotesParams,
  IPostShiftNoteParams,
  IPutShiftNoteParams,
  IShiftNote,
} from '@src/models/ShiftNote'
import { AxiosService } from '../config/config'
import { Endpoints } from '../config/endpoints'

export class ShiftNotesApi {
  constructor(private axios: AxiosService) {}

  getShiftNotes = async (params?: IGetShiftNotesParams) => {
    const response = await this.axios.get<IPayload<IShiftNote[]>>(Endpoints.getShiftNotes, params)
    return response
  }

  getShiftNote = async (id: number, params?: IGetShiftsParams) => {
    const response = await this.axios.get<IPayload<IShift>>(Endpoints.getShiftNote(id), params)
    return response
  }

  postShiftNote = async (params: IPostShiftNoteParams) => {
    const response = await this.axios.post<IPayload<IShiftNote>>(Endpoints.postShiftNote, params)
    return response
  }

  putShiftNote = async (id: number, params: IPutShiftNoteParams) => {
    const reponse = await this.axios.put<IPayload<IShift>>(Endpoints.putShiftNote(id), params)
    return reponse
  }

  deleteShiftNote = async (id: number) => {
    const response = await this.axios.delete(Endpoints.deleteShiftNote(id))
    return response
  }

  getActivityLogs = async (params?: IGetActivityLogsParams) => {
    const response = await this.axios.get<IPayload<IActivityLog[]>>(Endpoints.activityLogs, params)
    return response
  }
}
